import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import TextEditorButton from 'flarum/common/components/TextEditorButton';
import Modal from 'flarum/common/components/Modal';
app.initializers.add('val-ui-markdown-help', () => {
  class ValMarkdownHelpModal extends Modal {
    className() {
      return 'ValMarkdownHelpModal';
    }
    title() {
      return 'Aide à la mise en forme';
    }
    content() {
      return m('div', {
        className: 'Modal-body ValMarkdownHelp'
      }, m('h3', 'Mise en forme'), m('pre', m('code', `**gras**
*italique*
***gras + italique***
~barré~~

# Titre
## Sous-titre

> Citation

- Liste à puces
1. Liste numérotée

[Texte du lien](https://adresse...)

![Description](https://adresse/image.jpg)

||spoiler en ligne||

>! spoiler en bloc

[color=red]Texte en rouge[/color]`)), m('h3', 'Code'), m('pre', m('code', `~~~
bloc de code
~~`)), m('h3', 'Tableau'), m('pre', m('code', `| Gauche | Centre | Droite |
|:---|:---:|---:|
| A | B | C |`)), m('h3', 'Automatique'), m('p', 'URL d’une image seule → image affichée'), m('p', 'URL YouTube seule → lecteur vidéo'), m('div', {
        className: 'ValMarkdownHelp-actions'
      }, m('a', {
        className: 'Button',
        href: '/d/295-mettre-en-forme-vos-messages-avec-markdown'
      }, 'Voir la FAQ complète'), m('button', {
        className: 'Button Button--primary',
        type: 'button',
        onclick: function () {
          app.modal.close();
        }
      }, 'Fermer')));
    }
  }
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    items.add('val-markdown-help', TextEditorButton.component({
      icon: 'fas fa-question',
      title: 'Aide Markdown',
      onclick: function () {
        app.modal.show(ValMarkdownHelpModal);
      }
    }), 90);
  });
});